// Group XIII. 信息銜接/語篇 Cohesion and Discourse
// Complete data from "Grammar 90 Groups (GPT5) 5 Examples Each.txt"

export const group13Data = {
  id: "group_13",
  title: {
    tc: "信息銜接/語篇",
    sc: "信息衔接/语篇",
    en: "Cohesion and Discourse"
  },
  subtitle: {
    tc: "Cohesion and Discourse",
    sc: "Cohesion and Discourse",
    en: "Cohesion and Discourse"
  },
  icon: "🔗",
  difficulty: "advanced",
  color: "from-cyan-500 to-cyan-600",
  topics: [
    {
      id: "pro_forms",
      title: {
        tc: "指代 one/ones",
        sc: "指代 one/ones",
        en: "Pro-forms"
      },
      description: {
        tc: "學習指代詞 one/ones 的用法",
        sc: "学习指代词 one/ones 的用法",
        en: "Learn the usage of pro-forms one/ones"
      },
      icon: "👆",
      difficulty: "intermediate",
      examples: [
        {
          id: "pro_1",
          sentence: "I need a pen. Do you have a blue one?",
          analysis: "a blue one (pro-noun).",
          translation: {
            tc: "我需要一支筆。你有藍色的嗎？",
            sc: "我需要一支笔。你有蓝色的吗？",
            en: "I need a pen. Do you have a blue one?"
          }
        },
        {
          id: "pro_2",
          sentence: "These apples are sour; take the sweet ones.",
          analysis: "the sweet ones (pro-noun).",
          translation: {
            tc: "這些蘋果很酸；拿甜的。",
            sc: "这些苹果很酸；拿甜的。",
            en: "These apples are sour; take the sweet ones."
          }
        },
        {
          id: "pro_3",
          sentence: "Your bag is heavier than mine.",
          analysis: "Your bag (S) is (V) heavier (C) than (conj) mine (pro-noun).",
          translation: {
            tc: "你的包比我的重。",
            sc: "你的包比我的重。",
            en: "Your bag is heavier than mine."
          }
        },
        {
          id: "pro_4",
          sentence: "I prefer this version to that one.",
          analysis: "I (S) prefer (V) this version (O) to (Prep) that one (O2).",
          translation: {
            tc: "我比較喜歡這個版本而不是那個。",
            sc: "我比较喜欢这个版本而不是那个。",
            en: "I prefer this version to that one."
          }
        },
        {
          id: "pro_5",
          sentence: "Some students passed; others didn't.",
          analysis: "Some students (S) passed (V); others (S) did not (V).",
          translation: {
            tc: "一些學生通過了；其他的沒有。",
            sc: "一些学生通过了；其他的没有。",
            en: "Some students passed; others didn't."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：避免重複；注意單複數一致。",
        sc: "要点：避免重复；注意单复数一致。",
        en: "Key points: avoid repetition; pay attention to singular/plural agreement."
      }
    },
    {
      id: "ellipsis",
      title: {
        tc: "省略（簡答/並列）",
        sc: "省略（简答/并列）",
        en: "Ellipsis/Short Answers"
      },
      description: {
        tc: "學習省略結構的用法",
        sc: "学习省略结构的用法",
        en: "Learn the usage of ellipsis structures"
      },
      icon: "💬",
      difficulty: "intermediate",
      examples: [
        {
          id: "ellipsis_1",
          sentence: "\"Do you like it?\" \"Yes, I do.\"",
          analysis: "Yes (M), I (S) do (Aux).",
          translation: {
            tc: "\"你喜歡嗎？\" \"是的，我喜歡。\"",
            sc: "\"你喜欢吗？\" \"是的，我喜欢。\"",
            en: "\"Do you like it?\" \"Yes, I do.\""
          }
        },
        {
          id: "ellipsis_2",
          sentence: "\"Can she drive?\" \"She can.\"",
          analysis: "She (S) can (Modal).",
          translation: {
            tc: "\"她會開車嗎？\" \"她會。\"",
            sc: "\"她会开车吗？\" \"她会。\"",
            en: "\"Can she drive?\" \"She can.\""
          }
        },
        {
          id: "ellipsis_3",
          sentence: "Mary can play the guitar, and John the piano.",
          analysis: "John (S) (省略 can play) the piano (O).",
          translation: {
            tc: "瑪麗會彈吉他，約翰會彈鋼琴。",
            sc: "玛丽会弹吉他，约翰会弹钢琴。",
            en: "Mary can play the guitar, and John the piano."
          }
        },
        {
          id: "ellipsis_4",
          sentence: "\"Who did it?\" \"Tom.\"",
          analysis: "Tom (S) (省略 did it).",
          translation: {
            tc: "\"誰做的？\" \"湯姆。\"",
            sc: "\"谁做的？\" \"汤姆。\"",
            en: "\"Who did it?\" \"Tom.\""
          }
        },
        {
          id: "ellipsis_5",
          sentence: "Some work hard; others, not so much.",
          analysis: "others (S), not so much (省略 V).",
          translation: {
            tc: "一些人努力工作；其他人，不那麼多。",
            sc: "一些人努力工作；其他人，不那么多。",
            en: "Some work hard; others, not so much."
          }
        }
      ],
      teachingNotes: {
        tc: "要點：避免冗長；語境補全意義；注意正式度。",
        sc: "要点：避免冗长；语境补全意义；注意正式度。",
        en: "Key points: avoid verbosity; context completes meaning; pay attention to formality."
      }
    }
  ]
};
